import { Container } from "@mui/material";
import { Outlet } from "react-router";
import { DashboardLayout } from "../DashboardLayout/DashboardLayout";
import { NotFound } from "../Errors/NotFound";
import { useSession } from "../useSession/useSession";

export const OrionSecurePage: React.FC = () => {
  const { session } = useSession();

  if ((session?.OrionUserGroups?.length ?? 0) > 0) {
    return <Outlet />;
  }
  return (
    <DashboardLayout>
      <Container maxWidth={false}>
        <NotFound />
      </Container>
    </DashboardLayout>
  );
};
